import React from 'react';
import './ArchitecturalServices.css';
import useScrollToTop from './useScrollToTop';
import ReusableLanding from './ReusableLanding';
import image2 from '../img/kitchen_modern_classic.png';
import { FaBuilding, FaStore, FaUtensils, FaWarehouse, FaPuzzlePiece, FaBriefcase, FaCheckCircle, FaTools, FaFileContract, FaHandshake, FaPencilRuler, FaHardHat, FaKey, FaLifeRing } from 'react-icons/fa'; // Import relevant icons
import { Link } from 'react-router-dom';

const CommercialConstruction = () => {
    useScrollToTop();
    return (
        <>
            <ReusableLanding
                imageUrl={image2}
                title="Commercial Construction"
                description="Creating functional and inspiring commercial spaces is essential for business success. At Housekaar, we provide comprehensive commercial construction services for various industries."
            />
            <div className="architectural-services-page">
                <section className="services-overview">
                    <h2>Our Commercial Construction Services</h2>
                    <p>We offer a comprehensive suite of commercial construction services tailored to meet the unique needs of your business.</p>
                    <ul className="services-list">
                        <li><FaBriefcase className="service-icon" /> <strong>Office Buildings:</strong> Constructing modern, efficient, and adaptable office spaces designed to foster productivity and collaboration.</li>
                        <li><FaStore className="service-icon" /> <strong>Retail Spaces:</strong> Building attractive, functional, and customer-centric retail environments that enhance brand image and drive sales.</li>
                        <li><FaUtensils className="service-icon" /> <strong>Restaurants:</strong> Designing and building unique and inviting dining spaces that optimize flow, functionality, and customer experience.</li>
                        <li><FaWarehouse className="service-icon" /> <strong>Warehouses:</strong> Constructing durable, spacious, and strategically designed storage and distribution facilities to meet your operational needs.</li>
                        <li><FaPuzzlePiece className="service-icon" /> <strong>Tenant Improvements:</strong> Expertly renovating and customizing existing commercial spaces to align with your specific business requirements and brand identity.</li>
                    </ul>
                </section>

                <section className="benefits-section">
                    <h2>Benefits of Our Commercial Construction</h2>
                    <ul className="benefits-list">
                        <li className="card">
                            <div className="benefit-icon"><FaHandshake /></div>
                            <h3>Professional Project Management</h3>
                            <p>Ensuring your project is managed efficiently, transparently, and professionally, from initial concept to final completion, staying on time and within budget.</p>
                        </li>
                        <li className="card">
                            <div className="benefit-icon"><FaCheckCircle /></div>
                            <h3>Compliance and Safety</h3>
                            <p>Strictly adhering to all local and national building codes, safety regulations, and permitting requirements to ensure a safe and legally compliant construction process.</p>
                        </li>
                        <li className="card">
                            <div className="benefit-icon"><FaTools /></div>
                            <h3>Customized Solutions</h3>
                            <p>Tailoring our design and construction services to meet your specific business needs, operational workflows, and brand aesthetics, creating a space that works perfectly for you.</p>
                        </li>
                        <li className="card">
                            <div className="benefit-icon"><FaBuilding className="fa-rotate-90" /></div>
                            <h3>Efficient Space Utilization</h3>
                            <p>Maximizing the functionality and flow of your commercial space through thoughtful design and strategic construction techniques, optimizing every square foot.</p>
                        </li>
                    </ul>
                </section>

                <section className="process-section">
                    <h2>Our Process</h2>
                    <p>We follow a structured and collaborative process to deliver exceptional commercial construction projects.</p>
                    <ol className="process-list">
                        <li><FaPencilRuler className="process-icon" /> <strong>Project Planning:</strong> Collaboratively defining the project scope, goals, budget, and timeline through detailed discussions and analysis.</li>
                        <li><FaLifeRing className="process-icon" /> <strong>Design and Engineering:</strong> Developing comprehensive architectural plans, structural engineering specifications, and MEP (mechanical, electrical, plumbing) designs.</li>
                        <li><FaFileContract className="process-icon" /> <strong>Permitting and Approvals:</strong> Navigating the regulatory landscape and diligently obtaining all necessary permits and approvals from relevant authorities.</li>
                        <li><FaHardHat className="process-icon" /> <strong>Construction:</strong> Executing the construction phase with our team of experienced professionals, adhering to the highest standards of quality, safety, and efficiency.</li>
                        <li><FaKey className="process-icon" /> <strong>Handover and Support:</strong> Delivering the completed commercial space to you, conducting a thorough walkthrough, and providing ongoing support to ensure a smooth transition.</li>
                    </ol>
                </section>

                <section className="get-started-cta">
                    <h2>Create the Ideal Commercial Space for Your Business</h2>
                    <p>
                        Contact us today to discuss your commercial construction project. Let our expertise help you build a space that supports your business growth and success.
                    </p>
                    <Link to="/pricing">
                        <button className="custom-button">Contact Us</button>
                    </Link>
                </section>
            </div>
        </>
    );
};

export default CommercialConstruction;